import playlist from '@/scripts/libs/playlist';
import store from '@/scripts/store';
import { Model } from '@viddsee/server-api-client';
import { MiniTranslator } from '@/scripts/helpers/mini-translator';
import { AnalyticPayload } from '@/scripts/libs/analytic/types';
import { ActionOption } from '@/scripts/libs/action.types';

const miniI18n = new MiniTranslator({
  en: {
    'add-to': {
      'need-login': 'Want to add this film to your playlist? Sign up to create, customise and save your film collections on Viddsee!',
    },
  },
  id: {
    'add-to': {
      'need-login': 'Mau menambahkan film ini ke playlistmu? Daftar untuk membuat, menyesuaikan, dan menyimpan koleksi filmmu di Viddsee!',
    },
  },
  zh: {
    'add-to': {
      'need-login': '想把這部電影加入您的播放清單嗎？註冊免費帳戶即可創建、客制和收藏您獨有的電影播放列表！',
    },
  },
});

const actionOptions: ActionOption[] = [
  {
    label: window.I18n.t('share.actions.share'),
    permissions: {
      show: false,
    },
    action(): void {
      // do nothing
    },
  }, {
    label: window.I18n.t('playlist.actions.add') + window.I18n.t('common.into') + '...',
    icon: 'fa:plus',
    permissions: {
      needLogin: true,
    },
    permissionRejectionMessages: {
      needLogin: miniI18n.t('add-to.need-login'),
    },
    tracker(video: Model.Video.Info): AnalyticPayload {
      return ({
        category: 'playlist',
        action: 'open-manager',
        label: video.id,
      });
    },
    action(video: Model.Video.Info): void {
      playlist.openPlaylistManagerModal(video,
        () => { /**/ },
        (error) => {
          store.dispatch('notification/notify', {
            type: 'error',
            title: error.message,
          });
        },
      );
    },
  },
];

export default actionOptions;
